// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"377":"chat","545":"language"}[chunkId] + "." + {"377":"9adb8ebd","545":"eeff2f23"}[chunkId] + ".js";
};